export default {
    name: 'header',
    component() {
        return {
            // open: false,
            scrollTop: 0,
            visible: false,
            sticky: false,
            bg: false,
            offset: 0,
            offset2: 90,
            lastScrollTop: 0,
            subNav: '',
            subNavChild: '1',
            extraSubNavChild: "",
            filter: false,
            headerHeight: 0,
            // wasSticky: false,
            itemHover: false,
            homepage: false,
            // popup: false,
            selected: "",
            color: '',
            selectedColors: [],
            selectedMatCollections: [],
            selectedSizeCollections: [],
            selectedTypeCollections: [],

            init() {
                // const header = document.querySelector(".header");
                if (document.querySelector('body').classList.contains('index-template')) {
                    this.offset2 = window.innerHeight
                }

                this.stickyNav();
                window.addEventListener("scroll", () => {
                    this.stickyNav();
                });

                const colorParam = this.getURLParameter('color');
                if (colorParam !== '') {
                    this.color = colorParam;
                } else {
                    this.color = '';
                }

                setTimeout(() => {                    
                    const navs = document.querySelectorAll('[data-nav]');
                    navs.forEach(nav => {
                        const index = nav.dataset.nav;
                        const left = nav.offsetLeft;
                        document.querySelector(`[data-subnav="${index}"]`).style.paddingLeft = `${left}px`;
                    });
                }, 200);

                this.setInitParams("color");
                this.setInitParams("matCol");
                this.setInitParams("sizeCol");
                this.setInitParams("typeCol");

                let body = document.querySelector('body');

                if(document.querySelector("[data-announcement]") != null && !body.classList.contains('index-template') && document.querySelector("[data-header-absolute]") != null && document.querySelector("[data-header-absolute]").dataset.headerAbsolute == "true" ) {
                    // console.log(document.querySelector("[data-header-absolute]").dataset.headerAbsolute);
                    setTimeout(() => {
                        this.headerHeight = document.querySelector(".header").getBoundingClientRect().height;
                        document.querySelector("main").style.marginTop = `-${this.headerHeight}px`;
                        document.querySelector("header").style.position="sticky";

                    }, 10);

                    addEventListener("resize", (event) => {
                        this.headerHeight = 0;
                        this.headerHeight = document.querySelector(".header").getBoundingClientRect().height;
                        document.querySelector("main").style.marginTop = `-${this.headerHeight}px`;
                    });
                }
            },

            setInitParams(paramName) {
                const url = new URL(window.location);
                const queryString = window.location.search;
                const searchParams = new URLSearchParams(queryString);

                const paramsOrg = searchParams.getAll(paramName);
                const paramsStr = paramsOrg.toString();
                if(paramsStr.startsWith(".")) {
                    paramsStr.slice(1);
                }
                const paramsFinal = paramsStr.split(".");

                if(paramName == 'color') {
                    this.selectedColors = paramsFinal;
                    url.searchParams.set(paramName, this.selectedColors.join("."));
    
                    this.selectedColors.forEach((item, index) => {
                        if(item == '') {
                            this.selectedColors.splice(index, 1);
                        }
                    });
                } else if(paramName == 'matCol') {
                    this.selectedMatCollections = paramsFinal;
                    url.searchParams.set(paramName, this.selectedMatCollections.join("."));
    
                    this.selectedMatCollections.forEach((item, index) => {
                        if(item == '') {
                            this.selectedMatCollections.splice(index, 1);
                        }
                    });
                } else if(paramName == 'sizeCol') {
                    this.selectedSizeCollections = paramsFinal;
                    url.searchParams.set(paramName, this.selectedSizeCollections.join("."));
    
                    this.selectedSizeCollections.forEach((item, index) => {
                        if(item == '') {
                            this.selectedSizeCollections.splice(index, 1);
                        }
                    });
                } else if(paramName == 'typeCol') {
                    this.selectedTypeCollections = paramsFinal;
                    url.searchParams.set(paramName, this.selectedTypeCollections.join("."));
    
                    this.selectedTypeCollections.forEach((item, index) => {
                        if(item == '') {
                            this.selectedTypeCollections.splice(index, 1);
                        }
                    });
                }
            },

            getURLParameter(name) {
                name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
                var results = regex.exec(window.location.search);
                return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
            },

            stickyNav() {
                if (this.subNav !== '') return;

                const top =
                    window.scrollY ||
                    window.scrollTop ||
                    document.getElementsByTagName("html")[0].scrollTop;
                // let st = window.pageYOffset || document.documentElement.scrollTop;
        
                if (top > this.offset2) {
                    this.bg = true;
                    this.sticky = true;
                } else if (top > this.offset) {
                    this.sticky = true;
                    this.bg = false;
                } else {
                    this.sticky = false;
                    this.bg = false;
                }
            },

            getMobileFilterHeight() {
                if(window.innerWidth < 1000) {
                    setTimeout(() => { 
                        let filterToggleHeight = document.querySelector('[data-filter-toggle]').getBoundingClientRect().height;
                        let filter = document.querySelector("[data-filter]");
                        filter.style.maxHeight = `calc(100svh - ${filterToggleHeight}px)`;
                    }, 100);

                    window.addEventListener("resize", () => {
                        setTimeout(() => { 
                            let filterToggleHeight = document.querySelector('[data-filter-toggle]').getBoundingClientRect().height;
                            let filter = document.querySelector("[data-filter]");
                            filter.style.maxHeight = `calc(100svh - ${filterToggleHeight}px)`;
                        }, 100);
                    });
                }
            },

            setParam(param, item) {
                const url = new URL(window.location);

                if(param == 'color') {
                    if(this.selectedColors.includes(item)) {
                        let index = this.selectedColors.indexOf(item);
                        this.selectedColors.splice(index, 1);
                    } else {
                        this.selectedColors.push(item);
                    }
                    url.searchParams.set(param, this.selectedColors.join("."));
                } else if(param == 'matCol') {
                    if(this.selectedMatCollections.includes(item)) {
                        let index = this.selectedMatCollections.indexOf(item);
                        this.selectedMatCollections.splice(index, 1);
                    } else {
                        this.selectedMatCollections.push(item);
                    }
                    url.searchParams.set(param, this.selectedMatCollections.join("."));
                } else if(param == 'sizeCol') {
                    if(this.selectedSizeCollections.includes(item)) {
                        let index = this.selectedSizeCollections.indexOf(item);
                        this.selectedSizeCollections.splice(index, 1);
                    } else {
                        this.selectedSizeCollections.push(item);
                    }
                    url.searchParams.set(param, this.selectedSizeCollections.join("."));
                } else if(param == 'typeCol') {
                    if(this.selectedTypeCollections.includes(item)) {
                        let index = this.selectedTypeCollections.indexOf(item);
                        this.selectedTypeCollections.splice(index, 1);
                    } else {
                        this.selectedTypeCollections.push(item);
                    }
                    url.searchParams.set(param, this.selectedTypeCollections.join("."));
                }


                if(param != 'color') {
                    let total = this.selectedMatCollections.length + this.selectedSizeCollections.length + this.selectedTypeCollections.length;

                    if(total == 1) {
                        let chosenUrl = new URL(this.$el.dataset.url);
                        if(this.selectedMatCollections.length == 1) {
                            let item = document.querySelector(`[data-handle='${this.selectedMatCollections.join(".")}']`);
                            chosenUrl = new URL(item.dataset.url);
                            chosenUrl.searchParams.set("matCol", this.selectedMatCollections.join("."));
                            if(this.selectedColors.length > 0) {
                                chosenUrl.searchParams.set("color", this.selectedColors.join("."));
                            }
                        } else if(this.selectedSizeCollections.length == 1) {
                            let item = document.querySelector(`[data-handle='${this.selectedSizeCollections.join(".")}']`);
                            chosenUrl = new URL(item.dataset.url);
                            chosenUrl.searchParams.set("sizeCol", this.selectedSizeCollections.join("."));
                            if(this.selectedColors.length > 0) {
                                chosenUrl.searchParams.set("color", this.selectedColors.join("."));
                            }
                        } else if(this.selectedTypeCollections.length == 1) {
                            let item = document.querySelector(`[data-handle='${this.selectedTypeCollections.join(".")}']`);
                            chosenUrl = new URL(item.dataset.url);
                            chosenUrl.searchParams.set("typeCol", this.selectedTypeCollections.join("."));
                            if(this.selectedColors.length > 0) {
                                chosenUrl.searchParams.set("color", this.selectedColors.join("."));
                            }
                        }
                        window.location.href = chosenUrl;
                    } else {
                        let link = document.querySelector("[data-all-col]").dataset.allCol + "?" + url.searchParams.toString();
                        window.location.href = link;
                        window.history.pushState({}, "", url);
                    }
                } else {
                    window.history.pushState({}, "", url);
                }
        
            },

            checkFilters(classes) {
                let hasFilterColor = false;
                let hasFilterMatCollection = false;
                let hasFilterSizeCollection = false;
                let hasFilterTypeCollection = false;

                if(this.selectedColors.length == 0 && this.selectedMatCollections.length == 0 && this.selectedSizeCollections.length == 0 && this.selectedTypeCollections.length == 0) {
                    return true;
                } else {
                    let classesArr = classes.split(' ');

                    classesArr.forEach(item => {
                        if(this.selectedColors.length > 0) {
                            if(this.selectedColors.indexOf(item) != -1) {
                                hasFilterColor = true;
                            }
                        } else {
                            hasFilterColor = true;
                        }

                        if(this.selectedMatCollections.length > 0) {
                            if(this.selectedMatCollections.indexOf(item) != -1) {
                                hasFilterMatCollection = true;
                            }
                        } else {
                            hasFilterMatCollection = true;
                        }
                        
                        if(this.selectedSizeCollections.length > 0) {
                            if(this.selectedSizeCollections.indexOf(item) != -1) {
                                hasFilterSizeCollection = true;
                            }
                        } else {
                            hasFilterSizeCollection = true;
                        }

                        if(this.selectedTypeCollections.length > 0) {
                            if(this.selectedTypeCollections.indexOf(item) != -1) {
                                hasFilterTypeCollection = true;
                            }                        
                        } else {
                            hasFilterTypeCollection = true;
                        }
                    })

                    if(hasFilterColor && hasFilterMatCollection && hasFilterSizeCollection && hasFilterTypeCollection ) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        }
    }
}